import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lmc-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationSearchService {
  private readonly uri: string = `${environment.DO_URL}/v2`;
  constructor(private readonly http: HttpClient) {}

  deleteUserPageHistory(userName: string) {
    return this.http.delete(`${this.uri}/deleteUserPageHistory/${userName}`);
  }

  // Insert page history
  insertPageHistory(something: any, id: any, user: any): Observable<any> {
    const data = {
      dealName: something,
      recordID: id,
      username: user,
    };
    return this.http.post(`${this.uri}/pagehistory`, data);
  }

  getPageHistory(user: any): Observable<any> {
		const data = {
			username: user,
		};
		return this.http.post(`${this.uri}/getpagehistory`, data);
	}

}
